
import Box from "../Box";

import styled from "styled-components";
import { CIconButton, CText } from "@carrefour/design-system-components-react";
import BaseDashboardCard from "../BaseDashboardCard";
import {  DetentionTypology } from "../../types/operational";
import useBreakPoint from "../../utils/useBreakPoint";
import { useTranslation } from "react-i18next";
import { formatPercentage } from "../../utils/numberUtils";
import { useStores } from "../../context/storesContext";
import { COLORS } from "../../utils/colors";
import DeltaBadge from "../DeltaBadge";

const Text = styled(CText)`
  font-family: system-ui;
`;

const Link = styled(CText)`
  font-family: system-ui;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  border-collapse: collapse;
  color: #0970E6;
  padding-top: 20px;
  display: inline-flex;
  alignItems: center;
  cursor: pointer;
  
`;
const TextCustom = styled(CText)<{ color: string }>`
  font-family: system-ui;
  color: ${(props) => props?.color};
`;
const Table = styled.table`
  width: 100%;
  align-items: center;
  border-collapse: collapse;
`;
const Tr = styled.tr``;
const TrCustom = styled.tr<{ isLast: boolean }>`
  border-collapse: collapse;
  border-bottom: ${(props) => (props?.isLast ? "" : " 1px solid #f0f3f6")};
`;
const Th = styled.th<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
`;
const Td = styled.td<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
  padding-block: 8px;
`;
const HYPER_LINK = window?.config?.EXTERNAL_URLS?.LOOKER_HYPER;
const SUPER_LINK = window?.config?.EXTERNAL_URLS?.LOOKER_SUPER;
const SUCCESS_THRESHOLD = 97;
const WARNING_THRESHOLD = 94;

type TopPGCCardProps = {
  value: number;
  listValue: Array<DetentionTypology>;
  isUnavailable: boolean;
  messageError?: string;
  isLoading: boolean;
  importedDateTime?: string;
  openInformationModal: (title?: string) => void;
};

const BoxCustom = styled(Box)<{ gap: string }>`
  gap: ${(props) => props.gap};
  display: flex;
`;

const getColorTag = (
  value: number
): "default" | "success" | "error" | "warning" | "info" | undefined => {
  if (value === -1) return "default";

  if (value > SUCCESS_THRESHOLD) {
    return "success";
  } else if (value <= SUCCESS_THRESHOLD && value > WARNING_THRESHOLD) {
    return "warning";
  }

  return "error";
};
const getColorText = (value: number): string => {
  if (value === -1) return "black";

  if (value > SUCCESS_THRESHOLD) {
    return "#33691E";
  } else if (value <= SUCCESS_THRESHOLD && value > WARNING_THRESHOLD) {
    return "#CC4010";
  }

  return "#AA0D11";
};

const TypoCard = ({
  listValue,
  value,
  importedDateTime,
  ...res
}: TopPGCCardProps) => {
  const {t} =useTranslation();
  const isBreak = useBreakPoint();
    const { selectedStore } = useStores();

const openLooker = () => {
  let link;
  switch (selectedStore?.storeType) {
    case 'market':
      link = SUPER_LINK
      break;
    case 'hypermarket':
      link = HYPER_LINK
      break;
    default:
      break;
  }
  if(!!link) {
    window.open(link, '_blank', 'noopener,noreferrer')
  }
}
  return (
    <BaseDashboardCard
      hasModal={true}
      title={`${t('operationnel.detention_t1')}`}
      size={"big"}
      importedDateTime={importedDateTime}
      {...res}
    >
      <BoxCustom
        gap="1.5rem"
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <BoxCustom
          gap={`0.8rem`}
          flexDirection={"column"}
          alignItems={"center"}
          width="100%"
          borderRadius={1}
          pt={[1, 4]}
        >
          <Box display={"flex"} justifyContent={"center"} width={"100%"}>
            {/* Détention causes magasin */}
            <Box
              borderRadius={1}
              border={"1px solid #BDC7DA"}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              py={1}
              px={2}
              width={["auto", "50%"]}
            >
              <Box
                display={"flex"}
                alignItems={"baseline"}
                py={"4px"}
                pt={[0, 0]}
              >
                <TextCustom
                  color={getColorText(value)}
                  size={"m"}
                  tagStyle="h1"
                >{`${formatPercentage(value, "")}`}</TextCustom>
                <TextCustom
                  color={getColorText(value)}
                  tagStyle="p"
                >{`%`}
                </TextCustom>
              </Box>
            </Box>
          </Box>
        </BoxCustom>
        {/* famille */}
        <Box
          style={{
            display: isBreak === 'phone' ? 'block' : 'grid',
            gridTemplateColumns: isBreak === 'phone' ? undefined : '1fr 1fr',
            gap: isBreak === 'phone' ? undefined : '4rem',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Table>
            <thead>
              <Tr>
                <Th $textAlign={"left"}>
                  <Text bold size={"s"} tagStyle={"subtitle"} style={{color: COLORS.green, paddingBottom:"10px", textTransform: "uppercase"}}>
                    {t('operationnel.top5')}
                  </Text>
                </Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {listValue &&
                listValue?.length > 0 &&
                listValue?.slice(0,5).map((detention, index) =>
                  subElements(
                    detention,
                    isBreak,
                    listValue?.length === index + 1
                  )
                )}
            </tbody>
          </Table>

          <Table>
            <thead>
              <Tr>
                <Th $textAlign={"left"}>
                  <Text bold size={"s"} tagStyle={"subtitle"} style={{color: "#CC4010", paddingBottom:"10px", textTransform: "uppercase"}}>
                    {t('operationnel.flop5')}
                  </Text>
                </Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {listValue &&
                listValue?.length > 0 &&
                ([...listValue]?.reverse()).slice(0,5).map((detention, index) =>
                  subElements(
                    detention,
                    isBreak,
                    listValue?.length === index + 1
                  )
                )}
            </tbody>
          </Table>
        </Box>
      </BoxCustom>
      <Box>
 
        <Link size={"m"} bold onClick={openLooker}>
          <CIconButton
                          icon={"external-link"}
                          variation={"tertiary"}
                          tone={"main"}
                          style={{ marginRight: '5px',marginTop:'-8px'}}
                          size={"m"}
                        />
            {`${t('operationnel.all-families')}`}
        </Link>
      </Box>
    </BaseDashboardCard>
  );
};

export default TypoCard;

function subElements(detention: DetentionTypology, isBreak: string, isLast: boolean) {
  return (
    <TrCustom isLast={isLast} key={"topTypo" + detention.department}>
      <Td $textAlign={"left"}>
        <BoxCustom gap="2px" display={"flex"}>
          <Text size={"m"} tagStyle="p">
            {detention.department}
          </Text>
        </BoxCustom>
      </Td>
      <Td $textAlign={isBreak === "phone" ? "right" : "right"}>
        <DeltaBadge
          value={detention.rate}
          status={getColorTag(detention.rate)}
          showIcon={false}
          showSign={false}
        />
      </Td>
    </TrCustom>
  );
}
